import { render, staticRenderFns } from "./CompanyModule.vue?vue&type=template&id=1a479376&scoped=true"
import script from "./CompanyModule.vue?vue&type=script&lang=js"
export * from "./CompanyModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a479376",
  null
  
)

export default component.exports